// @ts-nocheck
/* eslint-disable */
import { setItem, getItem } from "~/es6/localstorage";
import { node } from "~/util/dom";
import { getItem as getCookie } from "~/util/cookies";
import { CONFIG } from "~/config";
import { WHITE_LIST_LOG_ACTION_IN_FRAME } from "~/util/constants";
import Scene from "~/scene";
import { store } from "~/state/store";
import { MAP_OVERLAYS } from "~/state/map/constants";
import { v4 as uuidv4 } from "uuid";
import { ELoginState } from "~/state/user/interfaces";

Mapy.Logger = class {
	constructor() {
		this._debugConf = {
			enabled: false,
			basic: false,
			default: false,
			query: ""
		};
		this._debugVisible = true;
		this._defaultArgs = ["lang", "userInfoScreenWidth", "userInfoViewPortSize", "userInfoPixelRatio", "location", "mapset"];
		this._queryList = [];
		this._dom = {};

		document.addEventListener("click", this, true);
		document.addEventListener("submit", this, true);

		/* prepsat ctrl-zoom, aby logoval */
		var oldStop = SMap.Control.Selection.prototype._stop;
		SMap.Control.Selection.prototype._stop = function(success) {
			if (success) { Mapy.getComponent("logger").log("ctrl-zoom"); }
			return oldStop.apply(this, arguments);
		}

		/* prepsat contextmenu, aby logovalo */
		var oldOpen = SMap.Control.ContextMenu.prototype.open;
		SMap.Control.ContextMenu.prototype.open = function(e, coords) {
			var c = Scene.coordsFromEvent(e).toWGS84();
			Mapy.getComponent("logger").log("menu", {eventx:c[0].toFixed(6), eventy:c[1].toFixed(6)});
			return oldOpen.apply(this, arguments);
		}

		// nastaveni AB testu
		if (CONFIG.abTest && window.DOT) {
			DOT.cfg({
				abtest: CONFIG.abTest.name,
				impress: false
			});
		}

		// lsid pro analytiku
		if (window.DOT) {
			let lsid = getCookie("User-Id") || "";

			DOT.cfg({
				lsid,
				impress: false
			});
		}

		// vytvorime po spusteni
		let debugConf = getItem("mapycomLoggerDebugConf");

		if (debugConf) {
			this._debugConf = JSON.parse(debugConf);
			this._debugConf.query = this._debugConf.query || "";
			this._setQueryList();
		}

		if (this._debugConf.enabled) {
			this._buildDebug();

			if (this._debugConf.basic) {
				this._setDebugBasic();
			}

			if (this._debugConf.default) {
				this._setDebugDefault();
			}
		}
	}

	log(action, d, defaultClick) {
		if (!window.DOT) { return; }

		var data = { ...d } || {};

		data.action = action;

		// pokud jsme v iframu a akce neni na whitelistu, tak neposilame do analytiky
		if (CONFIG.inFrame && WHITE_LIST_LOG_ACTION_IN_FRAME.indexOf(data.action) == -1) {
			return;
		}

		// budeme cist i veci ze store, takze si natahneme jeho stav
		const state = store.getState();

		// pro vybrane eventy pridame jazyk
		if (!("lang" in data)) {
			data.lang = CONFIG.defaultLang;
		}
		if (data.text && typeof data.text === "string") {
			data.text = data.text.replace(/[\t\n]/g, "");
		}

		//přidáme další iformace o uživateli
		//velikost obrazovky
		data.userInfoScreenWidth = screen && screen.width && screen.height ? screen.width + '×' + screen.height : "undetectable";
		//velikost viewportu
		data.userInfoViewPortSize = document.documentElement.clientWidth + "×" + document.documentElement.clientHeight;
		//pixelRatio
		data.userInfoPixelRatio = window.devicePixelRatio;
		// pozice uzivatele
		if (state.user.location.source !== 'none') {
			data.loc_source = state.user.location.source;
			data.loc_lat = state.user.location.latitude;
			data.loc_lon = state.user.location.longitude;
			data.loc_accuracy = state.user.location.accuracy;
			data.loc_timestamp = state.user.location.timestamp;
		}

		// queryId z hledani pridame, pokud logujici nedodal vlastni a jde o jednu z akci, co to maji posilat
		if (!("query_id" in data) && ["search_result", "search_selection"].indexOf(action) !== -1) {
			// pokud by se melo query_id poslat, ale neni ani v data, ani ve store, tak si jednorazove nejake vymyslime (melo by nastavat jen pri vyberu z naseptavace)
			data.query_id = state.search.queryId || uuidv4();
		}

		// mapset
		let mapset = state.map.mapset;

		if (Scene.isM3dActive()) {
			mapset += "_3D";
		} else {
			const panoComp = Mapy.getComponent("pano");

			if (panoComp && panoComp.isActive()) {
				mapset += "_pano";
			}

			if (mapset in state.map.currentOverlays && state.map.currentOverlays[mapset].indexOf(MAP_OVERLAYS.HILLSHADE) !== -1) {
				data.sklon = true;
			}
		}

		if (!("mapset" in data)) {
			data.mapset = mapset;
		}

		if (!("abCountry" in data)) {
			data.ab_country = CONFIG.abCountry;
		}

		const { user } = state.user;

		data.mapy_premium_hasPremium = false;
		if (user.state === ELoginState.Green && user.premium) {
			data = {
				...data,
				mapy_premium_hasPremium: user.premium,
				mapy_premium_isTrial: user.premiumData.subscriptions?.[0].isTrial || false,
				mapy_premium_isRecurring: user.premiumData.subscriptions?.[0].isRecurring || false,
				mapy_premium_purchaseDate: user.premiumData.subscriptions?.[0].purchaseDate ? user.premiumData.subscriptions?.[0].purchaseDate.split("T")[0] : "",
				mapy_premium_paymentProvider: user.premiumData.subscriptions?.[0].paymentPlatform,
				mapy_premium_freemium: user.premiumData.subscriptions?.[0].typeId === "mapy_free",
			};
		};

		DOT.hit("event", { d: data });

		if (this._debugConf.enabled) {
			// mame query list?
			if (this._queryList.length) {
				for (let i = 0, max = this._queryList.length; i < max; i++) {
					// spravny nazev akce?
					if (data.action.match(this._queryList[i])) {
						this._createDebugItem(data, defaultClick);
						break;
					}
				}
			}
			else {
				this._createDebugItem(data, defaultClick);
			}
		}
	}

	debug(state) {
		this._debugConf.enabled = state;

		this._saveDebugConf();

		if (!this._debugConf.enabled) {
			if (this._dom.container) {
				this._dom.container.remove();
				this._dom.container = null;
			}
		}
		else {
			// vytvorime
			if (!this._dom.container) {
				this._buildDebug();
			}
		}
	}

	handleEvent(e) {
		if (!window.DOT) { return; }

		/* fix pro firefox #text specialitku */
		var target = (e.target.nodeType == 3 ? e.target.parentNode : e.target);

		/* klikani na submit tlacitka ve formu bude chyceno v udalosti "submit" */
		if (e.type == "click" && target.type == "submit" && target.form) { return; }

		/* najit rodic, ktery ma pozadovany atribut nebo je spravneho typu */
		var dataNode = null;

		// vysledna data, co se zaloguji
		var data = {};

		var tmp = e.target;
		while (tmp && tmp.getAttribute) {
			if (tmp.getAttribute("data-log-action")) { // na tomhle se zastavime
				dataNode = tmp;
				break;
			}
			if ((tmp.nodeName.match(/^(a|button)$/i) || tmp.type == "button") && !tmp.hasAttribute("data-log-ignore")) { // tenhle bereme, ale jdeme dal
				dataNode = tmp;
				data.action = "click";
			}
			tmp = tmp.parentNode;
		}

		if (!dataNode) { return; } // vzniklo to mimo nas zajem

		if (dataNode.href) { data.url = dataNode.href; }

		// vysosame pripadna logovaci metadata
		for (var i=0;i<dataNode.attributes.length;i++) {
			var a = dataNode.attributes[i];
			var r = a.nodeName.match(/^data-log-(.*)/);

			if (r) {
				if (r[1] === "publicprofile") {
					r[1] = "publicProfile";
				}
				data[r[1]] = a.value;
			}
		}

		if (data.action == "click") {
			data.text = data.text || dataNode.textContent || "";
			if (!data.text && dataNode.id) { data.text = "#" + dataNode.id; }
			if (!data.text && dataNode.className) { data.text = "." + dataNode.className; }
		}

		this.log(data.action, data, true);
	}

	_buildDebug() {
		this._dom.container = node("div", { className: "logger-debug" });
		this._dom.list = node("ul", { className: "list" });
		let controls = node("div", { className: "controls" });
		this._dom.container.appendChild(controls);
		this._dom.container.appendChild(this._dom.list);
		let toggleBtn = node("button", { className: "btn toggle-btn", textContent: "Skrýt" });
		toggleBtn.addEventListener("click", e => {
			this._debugVisible = !this._debugVisible;
			this._dom.container.classList.toggle("small-view");
			toggleBtn.textContent = this._dom.container.classList.contains("small-view") ? "Zobrazit" : "Skrýt";
		});
		controls.appendChild(toggleBtn);
		this._dom.basicBtn = node("button", { className: "btn basic-btn" });
		this._dom.basicBtn.addEventListener("click", e => {
			this._debugConf.basic = !this._debugConf.basic;

			this._saveDebugConf();
			this._setDebugBasic();
		});
		controls.appendChild(this._dom.basicBtn);
		this._dom.defaultBtn = node("button", { className: "btn clear-btn" });
		this._dom.defaultBtn.addEventListener("click", e => {
			this._debugConf.default = !this._debugConf.default;

			this._saveDebugConf();
			this._setDebugDefault();
		});
		controls.appendChild(this._dom.defaultBtn);
		let closeBtn = node("button", { className: "btn disable-btn", textContent: "Zavřít" });
		closeBtn.addEventListener("click", e => {
			this.debug(false);
		});
		controls.appendChild(closeBtn);
		let queryInput = node("input", { type: "text", className: "query", placeholder: "seznam akcí oddělených mezerou", value: this._debugConf.query });
		queryInput.addEventListener("change", e => {
			this._debugConf.query = queryInput.value.trim();

			this._saveDebugConf();
			this._setQueryList();
		});
		controls.appendChild(queryInput);
		let queryClearBtn = node("button", { className: "btn", textContent: "Smazat" });
		queryClearBtn.addEventListener("click", e => {
			queryInput.value = "";
			this._debugConf.query = "";

			this._saveDebugConf();
			this._setQueryList();
		});
		controls.appendChild(queryClearBtn);
		let clearBtn = node("button", { className: "btn clear-btn", textContent: "Smazat list" });
		clearBtn.addEventListener("click", e => {
			this._dom.list.innerHTML = "";
		});
		controls.appendChild(clearBtn);
		// nechceme logovat vlastni cudly
		toggleBtn.setAttribute("data-log-ignore", "1");
		this._dom.basicBtn.setAttribute("data-log-ignore", "1");
		this._dom.defaultBtn.setAttribute("data-log-ignore", "1");
		clearBtn.setAttribute("data-log-ignore", "1");
		closeBtn.setAttribute("data-log-ignore", "1");
		queryClearBtn.setAttribute("data-log-ignore", "1");
		document.getElementById("scene").appendChild(this._dom.container);

		this._setDebugBasic();
		this._setDebugDefault();
	}

	_createDebugItem(data, defaultClick) {
		let item = node("li");
		if (defaultClick) {
			item.classList.add("default-click");
		}
		item.addEventListener("click", e => {
			// eslint-disable-next-line no-console
			console.log(data);
		});
		let dataObj = JSON.parse(JSON.stringify(data));
		let action = dataObj.action;
		delete dataObj.action;
		let params = [];
		let allParams = Object.keys(dataObj);
		allParams.sort((a, b) => {
			if (a == "text" && b != "text") return -1;
			else if (b == "text" && a != "text") return 1;
			else if (a == "text" && b == "text") return 0;
			else {
				return a.localeCompare(b);
			}
		});
		allParams.forEach((i, ind) => {
			let spanClass = this._defaultArgs.indexOf(i) != -1 ? " default-arg" : "";
			let comma = allParams.length - 1 != ind ? ", " : "";
			let value = dataObj[i];

			if (value && typeof value === "object") {
				value = JSON.stringify(value);
			}

			params.push(`<span class="param${spanClass}"><strong>${i}</strong>:${value}${comma}</span>`);
		});
		item.innerHTML = `<strong>${action} |</strong>` + params.join("");
		this._dom.list.appendChild(item);

		if (this._debugVisible) {
			item.scrollIntoView();
		}
	}

	_setDebugBasic() {
		this._dom.list.classList[this._debugConf.basic ? "add" : "remove"]("basic");
		this._dom.basicBtn.textContent = this._debugConf.basic ? "Full" : "Basic";
	}

	_setDebugDefault() {
		this._dom.list.classList[this._debugConf.default ? "add" : "remove"]("default");
		this._dom.defaultBtn.textContent = this._debugConf.default ? "Zapnout default click" : "Zrušit default click";
	}

	_setQueryList() {
		this._queryList = [];

		if (this._debugConf.query) {
			let parts = this._debugConf.query.split(" ");
			this._queryList = parts.map(i => new RegExp(i));
		}
	}

	_saveDebugConf() {
		setItem("mapycomLoggerDebugConf", JSON.stringify(this._debugConf));
	}
}
